import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { RuleHint, GAMLS_RULE } from "@/components/member/IdField";
import { AuthField } from "@/components/auth/AuthLayout";
import { BrandButton } from "@/components/PageHeader";
import { api, errMsg } from "@/lib/api";

const BLANK = { gamls_id: "", staff_id: "", name: "" };

export const EntryDialog = ({ entry, open, onClose, onSaved }) => {
  const [f, setF] = useState(BLANK);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) { setF(entry ? { gamls_id: entry.gamls_id || "", staff_id: entry.staff_id || "", name: entry.name || "" } : BLANK); }
  }, [open, entry]);
  const txt = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const save = async (e) => {
    e.preventDefault();
    if (!f.gamls_id.trim() && !f.staff_id.trim()) return toast.error("Enter a GAMLS ID or a Staff ID");
    setBusy(true);
    try {
      if (entry) await api.put(`/master-list/entries/${entry.id}`, f); else await api.post("/master-list/entries", f);
      toast.success(entry ? "Record updated" : "Record added to the master list");
      onSaved();
    } catch (err) { toast.error(errMsg(err)); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="master-entry-dialog">
        <DialogHeader><DialogTitle className="font-heading">{entry ? "Edit record" : "Add a record"}</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <AuthField label="GAMLS ID"><Input value={f.gamls_id} onChange={txt("gamls_id")} maxLength={12} placeholder="e.g. A12345678901" className="h-11 font-mono uppercase placeholder:normal-case" data-testid="master-entry-gamls-input" /><RuleHint rule={GAMLS_RULE} value={f.gamls_id} testId="master-entry-gamls" /></AuthField>
          <AuthField label="Staff ID"><Input value={f.staff_id} onChange={txt("staff_id")} placeholder="e.g. GHS-100126" className="h-11 font-mono uppercase placeholder:normal-case" data-testid="master-entry-staff-input" /></AuthField>
          <AuthField label="Name (optional)"><Input value={f.name} onChange={txt("name")} className="h-11" data-testid="master-entry-name-input" /></AuthField>
          <p className="text-xs text-gray-500">At least one ID is needed. Every member and registration is re-checked as soon as you save.</p>
          <BrandButton type="submit" disabled={busy} className="w-full h-11" data-testid="master-entry-save">{busy ? "Saving…" : entry ? "Save changes" : "Add record"}</BrandButton>
        </form>
      </DialogContent>
    </Dialog>
  );
};
